// HTML-entity decoder for displaying server-stored plain text in React.
//
// WHY: server-side `stripHtml` (sanitize-html, allowedTags: []) entity-encodes
// surviving text on write — `<`→`&lt;`, `&`→`&amp;`, etc. Plain-text fields are
// rendered into React TEXT sinks (`{value}`), which set textContent and do NOT
// decode entities, so users see literal `&lt;` / `&amp;` (e.g. a story titled
// "Fire & Ice" shows "Fire &amp; Ice"). This helper decodes for display.
//
// CONTRACT — TEXT SINKS ONLY. The output of decodeEntities() must only ever be
// rendered as a React text child / textContent. NEVER pass it to
// dangerouslySetInnerHTML, .innerHTML, or any HTML/markup sink (including
// `<script type="application/ld+json">` / JSON-LD), because decoding turns
// `&lt;script&gt;` back into live `<script>`. Rich-text fields (bio, story body)
// are sanitized + rendered via dangerouslySetInnerHTML and must NOT be run
// through this helper.
//
// Single-pass + order-safe: String.replace does not re-scan its own output, so
// `&amp;lt;` decodes to `&lt;` (the `&amp;` matches first → `&`, then `lt;` is
// not re-scanned), NOT to `<`. Unknown entities are left untouched.

const NAMED = { amp: '&', lt: '<', gt: '>', quot: '"', apos: "'" }

export function decodeEntities(str) {
  if (typeof str !== 'string' || str.indexOf('&') === -1) return str // fast path
  return str.replace(/&(#x[0-9a-f]+|#\d+|[a-z][a-z0-9]*);/gi, (m, ent) => {
    if (ent[0] === '#') {
      const cp = (ent[1] === 'x' || ent[1] === 'X')
        ? parseInt(ent.slice(2), 16)
        : parseInt(ent.slice(1), 10)
      return Number.isFinite(cp) ? String.fromCodePoint(cp) : m
    }
    const k = ent.toLowerCase()
    return Object.prototype.hasOwnProperty.call(NAMED, k) ? NAMED[k] : m
  })
}

export default decodeEntities
